import React, { useEffect, useRef, useState } from "react";
import { ContenedorParametros } from "../../components/utils/ContenedorParametros";
import { BotonProcesar } from "../../components/buttons/BotonProcesar";
import { useMantenimientosDefinidos } from "../../../hooks/gestionMantenimientos/useMantenimientosDefinidos";
import { Modal } from "../../components/modal/Modal";
import { useModal } from "../../../hooks/useModal";
import { BotonNuevo } from "../../components/buttons/BotonNuevo";
import { useRepuestos } from "../../../hooks/registros/useRepuestos";
import { capitalLetter, classNameInput, notify } from "../../../utils/utils";

export const MantenimientosDefinidos = () => {
    const refDiv = useRef()
    const refTabla = useRef()
    const repuestoDefault = {
        codRepuesto: 0,
        cantidad: 0
    }
    
    const [isOpenModalRegistro,openModalRegistro,closeModalRegistro] = useModal()
    const [isOpenModalEliminacion,openModalEliminacion,closeModalEliminacion] = useModal()
    const {
        listarMantenimientos,
        listarDetalladoProductos,
        mantenimientos,
        registrarEditarMantenimiento,
        eliminarMantenimientos
    } = useMantenimientosDefinidos()
    const {
        listarRepuestos,
        repuestos
    } = useRepuestos()


    const [nombreMantenimiento,setNombreMantenimiento] = useState('')
    const [descripcionMantenimiento,setDescripcionMantenimiento] = useState('')
    const [arrayRepuestos,setArrayRepuestos] = useState([repuestoDefault])
    const [codMantenimientoSeleccionado,setCodMantenimientoSeleccionado] = useState(0)

    useEffect(() => {
        const funcionReady = async () => {
            await listarMantenimientos()
            await listarRepuestos()
        }
        funcionReady()
    },[])

    const funcionRegistrarEditarMantenimiento = async () => {
        if(JSON.stringify(arrayRepuestos) == JSON.stringify([repuestoDefault]) || arrayRepuestos.some(e => [e.cantidad,e.codRepuesto].includes(0))){
            notify('Elegir productos y cantidades validas para los repuestos','info')
            return
        }
        const response = await registrarEditarMantenimiento({
            nombrePlantilla             : nombreMantenimiento,
            descripcionPlantilla        : descripcionMantenimiento,
            detallePlantilla            : arrayRepuestos,
            codPlantilla   : codMantenimientoSeleccionado
        })
        notify(response.DesResultado,response.CodResultado == 1 ? 'success' : 'error')
        if(response.CodResultado == 1){
            closeModalRegistro()
            await listarMantenimientos()
        }
    }

    const funcionEliminarMantenimiento = async (codMantenimientoPlantilla) => {
        const response = await eliminarMantenimientos(codMantenimientoPlantilla)
        notify(response.DesResultado,response.CodResultado == 1 ? 'success' : 'error')
        if(response.CodResultado == 1){
            closeModalEliminacion()
            await listarMantenimientos()
        }
    }

    const editarArrayRepuestos = (key,valor,indice) => {
        setArrayRepuestos((valorAnterior) => {
            const nuevoArray = [...valorAnterior]
            nuevoArray[indice] = {
                ...nuevoArray[indice],
                [key]: valor
            }
            return nuevoArray
        })
    }
    
    return (
        <>
            <div className="w-full h-full flex flex-col">
                <ContenedorParametros
                    titulo="Mantenimientos predefinidos"
                >
                    <BotonNuevo
                        onClick={() => {
                            openModalRegistro()
                            setNombreMantenimiento('')
                            setDescripcionMantenimiento('')
                            setArrayRepuestos([repuestoDefault])
                            setCodMantenimientoSeleccionado(0)
                        }}
                    />
                    <BotonProcesar
                        onClick={listarMantenimientos}
                    />
                </ContenedorParametros>

                <div className="overflow-auto flex-grow pt-7">
                    <table className="tableResponsive">
                        <thead>
                            <tr>
                                <th className="text-left">Nº</th>
                                <th className="text-left">NOMBRE MANTENIMIENTO</th>
                                <th className="text-left">FECHA REGISTRO</th>
                                <th className="text-left"></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                mantenimientos.length == 0 ? <tr><td colSpan={5} className="text-center">No hay información con los parametros seleccionados</td></tr>
                                :
                                mantenimientos.map((data,i) => (
                                    <tr key={i+1}>
                                        <td data-label="N">{i+1}</td>
                                        <td data-label="Nombre mantenimiento">{data.nomMantenimientoPlantilla}</td>
                                        <td data-label="Fecha registro">{data.fechaRegistro}</td>
                                        <td data-label="Estado" className="w-[100px] lg:!flex justify-between"><div className={`rounded ${data.codEstado == 1 ? 'bg-green-600' : 'bg-orange-600'} text-xs p-1 text-center`}>{capitalLetter(data.nomEstado)}</div></td>
                                        <td data-label="Opciones" className="w-[100px] lg:!flex justify-between text-xs">
                                            <div className="flex gap-2 items-center justify-center">
                                                <button onClick={async () => {
                                                    setCodMantenimientoSeleccionado(data.codMantenimientoPlantilla)
                                                    openModalRegistro()
                                                    setNombreMantenimiento(data.nomMantenimientoPlantilla)
                                                    setDescripcionMantenimiento(data.descripcion)
                                                    const detalladoRepuestos = await listarDetalladoProductos(data.codMantenimientoPlantilla)
                                                    setArrayRepuestos(detalladoRepuestos.map((elem) => (
                                                        {
                                                            codRepuesto: elem.codRepuesto,
                                                            cantidad: elem.cantidad || 0
                                                        }
                                                    )))
                                                }} title="Editar" className="w-[30px] h-[30px] rounded bg-blue-600"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                                                <button onClick={() => {setCodMantenimientoSeleccionado(data.codMantenimientoPlantilla);openModalEliminacion()}} title="Eliminar" className="w-[30px] h-[30px] rounded bg-red-600"><i className="fa fa-trash" aria-hidden="true"></i></button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>

                <Modal
                    isOpen      = {isOpenModalRegistro}
                    action      = {funcionRegistrarEditarMantenimiento}
                    closeModal  = {closeModalRegistro}
                    title       = {codMantenimientoSeleccionado == 0 ? 'Registrar mantenimiento' : 'Editar mantenimiento'}
                >
                    <div className="w-[500px] lg:w-full flex flex-col gap-4 p-5 lg:p-0">
                        <div className="flex flex-col gap-2">
                            <span>Nombre:</span>
                            <input type="text" placeholder="(Nombre)" value={nombreMantenimiento} onChange={e => setNombreMantenimiento(e.target.value)} className={classNameInput} />
                        </div>
                        <div className="flex flex-col gap-2">
                            <span>Descripción:</span>
                            <textarea value={descripcionMantenimiento} placeholder="(Descripción)" onChange={e => setDescripcionMantenimiento(e.target.value)} className={`${classNameInput} h-[80px] py-2`}></textarea>
                        </div>
                        <span>Repuestos: </span>
                        <div ref={refTabla} className="max-h-[200px] lg:w-full overflow-auto containerScroll">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Nº</th>
                                        <th>PRODUCTO</th>
                                        <th>CANTIDAD</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        arrayRepuestos.map((data,i) => 
                                            <tr key={i+1}>
                                                <td className="text-center">{i+1}</td>
                                                <td className="text-center">
                                                    <select 
                                                        value={data.codRepuesto} 
                                                        onChange={e => {
                                                            if(arrayRepuestos.some(data => data.codRepuesto == e.target.value)){
                                                                notify('El repuesto ya esta registrado','info')
                                                            }else{
                                                                editarArrayRepuestos('codRepuesto',Number(e.target.value),i)
                                                            }
                                                        }} 
                                                        className={`${classNameInput} w-[200px] lg:w-full`}
                                                    >
                                                        <option value="0">-- Seleccione --</option>
                                                        {repuestos.map((data,j) => <option key={j+1} value={data.codRepuesto}>{data.nombreRepuesto}</option>)}
                                                    </select>
                                                </td>
                                                <td className="text-center">
                                                    <input className={`${classNameInput} w-[100px] lg:w-[50px]`} value={data.cantidad} onChange={e => editarArrayRepuestos('cantidad',Number(e.target.value),i)} type="number" min={0} />
                                                </td>
                                                <td>
                                                    <div className="flex gap-2">
                                                        <button onClick={() => {
                                                            if(arrayRepuestos.length == 1){
                                                                setArrayRepuestos([repuestoDefault])
                                                            }else{
                                                                setArrayRepuestos(arrAnterior => {
                                                                    const arrCopy = [...arrAnterior]
                                                                    arrCopy.splice(i,1)
                                                                    return arrCopy
                                                                })
                                                            }
                                                        }} className="rounded w-5 h-5 bg-red-600 text-xs" title="QuitarRepuesto"><i className="fa fa-trash" aria-hidden="true"></i></button>
                                                        {
                                                            i == arrayRepuestos.length-1 ?
                                                            <button 
                                                                onClick={() => {
                                                                    const ultimoRepuesto = arrayRepuestos[arrayRepuestos.length-1]
                                                                    if([ultimoRepuesto.codRepuesto,ultimoRepuesto.cantidad].includes(0)){
                                                                        notify('Seleccionar un producto y una cantidad válida','info')
                                                                    }else{
                                                                        setArrayRepuestos([...arrayRepuestos,repuestoDefault])
                                                                    }
                                                                }} 
                                                                className="rounded w-[20px] h-[20px] bg-green-600 text-xs"
                                                                title="Agregar repuesto"
                                                            >
                                                                <i className="fa fa-plus" aria-hidden="true"></i>
                                                            </button>
                                                            : ''
                                                        }
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Modal>

                <Modal
                    title={'Eliminar mantenimiento'}
                    isOpen={isOpenModalEliminacion}
                    closeModal={closeModalEliminacion}
                    action={() => funcionEliminarMantenimiento(codMantenimientoSeleccionado)}
                    textButtons={{confirm:'Sí',denied:'No'}}
                >
                    <div className="w-[400px] lg:w-full py-4 text-center">
                        <span className="font-semibold">¿Está seguro de eliminar el mantenimiento?</span>
                    </div>
                </Modal>
            </div>
        </>
    )
};
